import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer');

// Views
const Dashboard = () => import('@/views/Dashboard');

// const Colors = () => import('@/views/theme/Colors');
// const Typography = () => import('@/views/theme/Typography');
//
// const Charts = () => import('@/views/Charts');
// const Widgets = () => import('@/views/Widgets');
//
// // Views - Components
// const Cards = () => import('@/views/base/Cards');
// const Switches = () => import('@/views/base/Switches');
// const Tabs = () => import('@/views/base/Tabs');
// const Breadcrumbs = () => import('@/views/base/Breadcrumbs');
// const Carousels = () => import('@/views/base/Carousels');
// const Collapses = () => import('@/views/base/Collapses');
// const Jumbotrons = () => import('@/views/base/Jumbotrons');
// const ListGroups = () => import('@/views/base/ListGroups');
// const Navs = () => import('@/views/base/Navs');
// const Navbars = () => import('@/views/base/Navbars');
// const Paginations = () => import('@/views/base/Paginations');
// const Popovers = () => import('@/views/base/Popovers');
// const ProgressBars = () => import('@/views/base/ProgressBars');
// const Tooltips = () => import('@/views/base/Tooltips');
//
// // Views - Buttons
// const StandardButtons = () => import('@/views/buttons/StandardButtons');
// const ButtonGroups = () => import('@/views/buttons/ButtonGroups');
// const Dropdowns = () => import('@/views/buttons/Dropdowns');
// const BrandButtons = () => import('@/views/buttons/BrandButtons');
//
// // Views - Editors
// const TextEditors = () => import('@/views/editors/TextEditors');
// const CodeEditors = () => import('@/views/editors/CodeEditors');
//
// // Views - Forms
// const BasicForms = () => import('@/views/forms/BasicForms');
// const AdvancedForms = () => import('@/views/forms/AdvancedForms');
// const ValidationForms = () => import('@/views/forms/ValidationForms');
//
// // Views GoogleMaps
// const GoogleMaps = () => import('@/views/GoogleMaps');
//
// // Views - Icons
// const Flags = () => import('@/views/icons/Flags');
// const FontAwesome = () => import('@/views/icons/FontAwesome');
// const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons');
// const CoreUIIcons = () => import('@/views/icons/CoreUIIcons');
//
// // Views - Notifications
// const Alerts = () => import('@/views/notifications/Alerts');
// const Badges = () => import('@/views/notifications/Badges');
// const Modals = () => import('@/views/notifications/Modals');
// const Toastr = () => import('@/views/notifications/Toastr');
//
// // Views - Tables
// const Tables = () => import('@/views/tables/Tables');
// const DataTable = () => import('@/views/tables/DataTable');
//
//
// // Users
// const Users = () => import('@/views/users/Users');
// const User = () => import('@/views/users/User');
//
// // Plugins
// const Draggable = () => import('@/views/plugins/Draggable');
// const Calendar = () => import('@/views/plugins/Calendar');
// const Spinners = () => import('@/views/plugins/Spinners');
//
// // Views - UI Kits
// const Invoice = () => import('@/views/apps/invoicing/Invoice');
// const Compose = () => import('@/views/apps/email/Compose');
// const Inbox = () => import('@/views/apps/email/Inbox');
// const Message = () => import('@/views/apps/email/Message');

// const Register = () => import('@/views/pages/Register');

// // Views - Pages

const Page404 = () => import('@/views/pages/Page404');
const Page500 = () => import('@/views/pages/Page500');
const Login = () => import('@/views/pages/Login');

const NsbAdminLeads = () => import('@/views/nsb/admin/Leads');
const NsbAdminCalls = () => import('@/views/nsb/admin/Calls');
const NsbAdminIndex = () => import('@/views/nsb/admin/Index');
const NsbAdminLogs = () => import('@/views/nsb/admin/Logs');
const NsbAdminFileViewer = () => import('@/views/nsb/admin/FileViewer');
const NsbAdminQueue = () => import('@/views/nsb/admin/Queue');
const NsbAdminOrders = () => import('@/views/nsb/admin/Orders');
const NsbAdminVouchers = () => import('@/views/nsb/admin/Vouchers');
const NsbAdminHelp = () => import('@/views/nsb/admin/Help');
const NsbAdminBotPhrases = () => import('@/views/nsb/admin/BotPhrases');

const NsbAdminCompanies = () => import('@/views/nsb/admin/Companies');
const NsbAdminCompany = () => import('@/views/nsb/admin/Company');
const NsbAdminUsers = () => import('@/views/nsb/admin/Users');
const NsbAdminUser = () => import('@/views/nsb/admin/User');

const NsbAgentVouchers = () => import('@/views/nsb/agent/Vouchers');
const NsbAgentVoucher = () => import('@/views/nsb/agent/Voucher');
const NsbAgentOrders = () => import('@/views/nsb/agent/Orders');
const NsbAgentOrder = () => import('@/views/nsb/agent/Order');
const NsbAgentTourHelper = () => import('@/views/nsb/agent/TourHelper');
const NsbAgentSearch = () => import('@/views/nsb/agent/Search');
const NsbAgentReports = () => import('@/views/nsb/agent/Reports');
const NsbAgentCustomers = () => import('@/views/nsb/agent/Customers');
const NsbAgentCustomer = () => import('@/views/nsb/agent/Customer');

const NsbTechRegions = () => import('@/views/nsb/tech/Regions');
const NsbTechCities = () => import('@/views/nsb/tech/Cities');
const NsbTechHotels = () => import('@/views/nsb/tech/Hotels');
const NsbTechHotelTypes = () => import('@/views/nsb/tech/Htypes');
const NsbTechDiseases = () => import('@/views/nsb/tech/Diseases');
const NsbTechDiseaseCategories = () => import('@/views/nsb/tech/DiseaseCategories');
const NsbTechRoomServices = () => import('@/views/nsb/tech/RoomServices');
const NsbTechHotelServices = () => import('@/views/nsb/tech/HotelServices');
const NsbTechWebform = () => import('@/views/nsb/tech/Webform');

const NsbTechCity = () => import('@/views/nsb/tech/City');
const NsbTechHotel = () => import('@/views/nsb/tech/Hotel');

const NsbAgencyDataExport = () => import('@/views/nsb/agency/DataExport');
const NsbAgencyDataImport = () => import('@/views/nsb/agency/DataImport');
const NsbAgencyVouchers = () => import('@/views/nsb/agency/Vouchers');
const NsbAgencyOrders = () => import('@/views/nsb/agency/Orders');
const NsbAgencyFees = () => import('@/views/nsb/agency/Fees');
const NsbAgencyReports = () => import('@/views/nsb/agency/Reports');
const NsbAgencyPayments = () => import('@/views/nsb/agency/Payments');
const NsbAgencyFinances = () => import('@/views/nsb/agency/Finances');
const NsbAgencyProfile = () => import('@/views/nsb/agency/Profile');
const NsbAgencyAccount = () => import('@/views/nsb/agency/Account');

const NsbBuhDataExport = () => import('@/views/nsb/buh/DataExport');
const NsbBuhDataImport = () => import('@/views/nsb/buh/DataImport');
const NsbBuhBalances = () => import('@/views/nsb/buh/Balances');
const NsbBuhPayments = () => import('@/views/nsb/buh/Payments');
const NsbBuhFinances = () => import('@/views/nsb/buh/Finances');
const NsbBuhReports = () => import('@/views/nsb/buh/Reports');

const NsbPanelMessages = () => import('@/views/nsb/panel/Messages');
const NsbPanelTasks = () => import('@/views/nsb/panel/Tasks');
const NsbPanelTask = () => import('@/views/nsb/panel/Task');
const NsbPanelNewBug = () => import('@/views/nsb/panel/NewBug');
const NsbPanelNewFeature = () => import('@/views/nsb/panel/NewFeature');
const NsbPanelCheckins = () => import('@/views/nsb/panel/Checkins');
const NsbPanelProfile = () => import('@/views/nsb/panel/Profile');

const NsbPanelTelecalls = () => import('@/views/nsb/panel/Telecalls');
const NsbIncomingX = () => import('@/views/nsb/panel/IncomingX');
const NsbIncoming = () => import('@/views/nsb/panel/Incoming');

const NsbManagerVouchers = () => import('@/views/nsb/manager/Vouchers');
const NsbManagerBooking = () => import('@/views/nsb/manager/Booking');
const NsbManagerBookingEx = () => import('@/views/nsb/manager/BookingEx');
const NsbManagerBookings = () => import('@/views/nsb/manager/Bookings');
const NsbManagerQuotas = () => import('@/views/nsb/manager/Quotas');

const NsbWebmasterWebform = () => import('@/views/nsb/webmaster/Webform');

const NsbHelp = () => import('@/views/nsb/panel/Help');
const NsbReports = () => import('@/views/nsb/panel/Reports');
const NsbLines = () => import('@/views/nsb/panel/Lines');

const SmStates = () => import('@/views/sm/States');
const SmOperations = () => import('@/views/sm/Operations');
const SmOperation = () => import('@/views/sm/Operation');
const SmState = () => import('@/views/sm/State');
const SmConditions = () => import('@/views/sm/Conditions');
const SmCondition = () => import('@/views/sm/Condition');
const SmExport = () => import('@/views/sm/Export');
const SmFunctions = () => import('@/views/sm/Funcs');
const SmFunction = () => import('@/views/sm/Func');

Vue.use(Router)

const router = new Router({
    mode: 'hash', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/',
            redirect: '/home',
            name: 'Главная',
            component: DefaultContainer,
            children: [
                {
                    path: 'home',
                    name: 'Home',
                    component: Dashboard
                },
                // {
                //     path: 'theme',
                //     redirect: '/theme/colors',
                //     name: 'Theme',
                //     component: {
                //         render (c) { return c('router-view') }
                //     },
                //     children: [
                //         {
                //             path: 'colors',
                //             name: 'Colors',
                //             component: Colors
                //         },
                //         {
                //             path: 'typography',
                //             name: 'Typography',
                //             component: Typography
                //         }
                //     ]
                // },
                // {
                //     path: 'charts',
                //     name: 'Charts',
                //     component: Charts
                // },
                // {
                //     path: 'widgets',
                //     name: 'Widgets',
                //     component: Widgets
                // },
                // {
                //     path: 'users',
                //     meta: { label: 'Users'},
                //     component: {
                //         render (c) { return c('router-view') }
                //     },
                //     children: [
                //         {
                //             path: '',
                //             component: Users,
                //         },
                //         {
                //             path: ':id',
                //             meta: { label: 'User Details'},
                //             name: 'User',
                //             component: User,
                //         },
                //     ]
                // },
                // {
                //     path: 'base',
                //     redirect: '/base/cards',
                //     name: 'Base',
                //     component: {
                //         render (c) { return c('router-view') }
                //     },
                //     children: [
                //         {
                //             path: 'breadcrumbs',
                //             name: 'Breadcrumbs',
                //             component: Breadcrumbs
                //         },
                //         {
                //             path: 'cards',
                //             name: 'Cards',
                //             component: Cards
                //         },
                //         {
                //             path: 'carousels',
                //             name: 'Carousels',
                //             component: Carousels
                //         },
                //         {
                //             path: 'collapses',
                //             name: 'Collapses',
                //             component: Collapses
                //         },
                //         {
                //             path: 'jumbotrons',
                //             name: 'Jumbotrons',
                //             component: Jumbotrons
                //         },
                //         {
                //             path: 'list-groups',
                //             name: 'List Groups',
                //             component: ListGroups
                //         },
                //         {
                //             path: 'navs',
                //             name: 'Navs',
                //             component: Navs
                //         },
                //         {
                //             path: 'navbars',
                //             name: 'Navbars',
                //             component: Navbars
                //         },
                //         {
                //             path: 'paginations',
                //             name: 'Paginations',
                //             component: Paginations
                //         },
                //         {
                //             path: 'popovers',
                //             name: 'Popovers',
                //             component: Popovers
                //         },
                //         {
                //             path: 'progress-bars',
                //             name: 'Progress Bars',
                //             component: ProgressBars
                //         },
                //         {
                //             path: 'switches',
                //             name: 'Switches',
                //             component: Switches
                //         },
                //         {
                //             path: 'tabs',
                //             name: 'Tabs',
                //             component: Tabs
                //         },
                //         {
                //             path: 'tooltips',
                //             name: 'Tooltips',
                //             component: Tooltips
                //         }
                //     ]
                // },
                // {
                //     path: 'buttons',
                //     redirect: '/buttons/standard-buttons',
                //     name: 'Buttons',
                //     component: {
                //         render (c) { return c('router-view') }
                //     },
                //     children: [
                //         {
                //             path: 'standard-buttons',
                //             name: 'Standard Buttons',
                //             component: StandardButtons
                //         },
                //         {
                //             path: 'button-groups',
                //             name: 'Button Groups',
                //             component: ButtonGroups
                //         },
                //         {
                //             path: 'dropdowns',
                //             name: 'Dropdowns',
                //             component: Dropdowns
                //         },
                //         {
                //             path: 'brand-buttons',
                //             name: 'Brand Buttons',
                //             component: BrandButtons
                //         }
                //     ]
                // },
                // {
                //     path: 'editors',
                //     redirect: '/editors/text-editors',
                //     name: 'Editors',
                //     component: {
                //         render (c) { return c('router-view') }
                //     },
                //     children: [
                //         {
                //             path: 'text-editors',
                //             name: 'Text Editors',
                //             component: TextEditors
                //         },
                //         {
                //             path: 'code-editors',
                //             name: 'Code Editors',
                //             component: CodeEditors
                //         }
                //     ]
                // },
                // {
                //     path: 'forms',
                //     redirect: '/forms/basic-forms',
                //     name: 'Forms',
                //     component: {
                //         render (c) { return c('router-view') }
                //     },
                //     children: [
                //         {
                //             path: 'basic-forms',
                //             name: 'Basic Forms',
                //             component: BasicForms
                //         },
                //         {
                //             path: 'advanced-forms',
                //             name: 'Advanced Forms',
                //             component: AdvancedForms
                //         },
                //         {
                //             path: 'validation-forms',
                //             name: 'Form Validation',
                //             component: ValidationForms
                //         }
                //     ]
                // },
                // {
                //     path: 'google-maps',
                //     name: 'Google Maps',
                //     component: GoogleMaps
                // },
                // {
                //     path: 'icons',
                //     redirect: '/icons/font-awesome',
                //     name: 'Icons',
                //     component: {
                //         render (c) { return c('router-view') }
                //     },
                //     children: [
                //         {
                //             path: 'coreui-icons',
                //             name: 'CoreUI Icons',
                //             component: CoreUIIcons
                //         },
                //         {
                //             path: 'flags',
                //             name: 'Flags',
                //             component: Flags
                //         },
                //         {
                //             path: 'font-awesome',
                //             name: 'Font Awesome',
                //             component: FontAwesome
                //         },
                //         {
                //             path: 'simple-line-icons',
                //             name: 'Simple Line Icons',
                //             component: SimpleLineIcons
                //         }
                //     ]
                // },
                // {
                //     path: 'notifications',
                //     redirect: '/notifications/alerts',
                //     name: 'Notifications',
                //     component: {
                //         render (c) { return c('router-view') }
                //     },
                //     children: [
                //         {
                //             path: 'alerts',
                //             name: 'Alerts',
                //             component: Alerts
                //         },
                //         {
                //             path: 'badges',
                //             name: 'Badges',
                //             component: Badges
                //         },
                //         {
                //             path: 'modals',
                //             name: 'Modals',
                //             component: Modals
                //         },
                //         {
                //             path: 'toastr',
                //             name: 'Toastr',
                //             component: Toastr
                //         }
                //     ]
                // },
                // {
                //     path: 'plugins',
                //     redirect: '/plugins/draggable',
                //     name: 'Plugins',
                //     component: {
                //         render (c) { return c('router-view') }
                //     },
                //     children: [
                //         {
                //             path: 'draggable',
                //             name: 'Draggable Cards',
                //             component: Draggable
                //         },
                //         {
                //             path: 'calendar',
                //             name: 'Calendar',
                //             component: Calendar
                //         },
                //         {
                //             path: 'spinners',
                //             name: 'Spinners',
                //             component: Spinners
                //         },
                //     ]
                // },
                // {
                //     path: 'tables',
                //     redirect: '/tables/tables',
                //     name: 'Tables',
                //     component: {
                //         render (c) { return c('router-view') }
                //     },
                //     children: [
                //         {
                //             path: 'tables',
                //             name: 'Simple Tables',
                //             component: Tables
                //         },
                //         {
                //             path: 'data-table',
                //             name: 'Data Table',
                //             component: DataTable
                //         },
                //     ]
                // },
                // {
                //     path: 'apps',
                //     name: 'Apps',
                //     component: {
                //         render (c) { return c('router-view') }
                //     },
                //     children: [
                //         {
                //             path: 'invoicing',
                //             redirect: '/apps/invoicing/invoice',
                //             name: 'Invoicing',
                //             component: {
                //                 render (c) { return c('router-view') }
                //             },
                //             children: [
                //                 {
                //                     path: 'invoice',
                //                     name: 'Invoice',
                //                     component: Invoice
                //                 }
                //             ]
                //         },
                //         {
                //             path: 'email',
                //             redirect: '/apps/email/inbox',
                //             name: 'Email',
                //             component: {
                //                 render (c) { return c('router-view') }
                //             },
                //             children: [
                //                 {
                //                     path: 'compose',
                //                     name: 'Compose',
                //                     component: Compose
                //                 },
                //                 {
                //                     path: 'inbox',
                //                     name: 'Inbox',
                //                     component: Inbox
                //                 },
                //                 {
                //                     path: 'message',
                //                     name: 'Message',
                //                     component: Message
                //                 }
                //             ]
                //         }
                //     ]
                // },

                {
                    path: 'admin',
                    redirect: '/admin/leads',
                    name: 'Админ',
                    // 2 пробела в начале
                    component: {
                        render (c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'Все функции',
                            component: NsbAdminIndex
                        },
                        {
                            path: 'leads',
                            meta: {title: 'Админ: лиды'},
                            name: 'Лиды',
                            component: NsbAdminLeads
                        },
                        {
                            path: 'telecalls',
                            meta: {title: 'Админ: звонки'},
                            name: 'Звонки',
                            component: NsbAdminCalls
                        },
                        {
                            path: 'logs',
                            meta: {title: 'Админ: логи'},
                            name: 'Логи',
                            component: NsbAdminLogs
                        },
                        {
                            path: 'errorlog',
                            meta: {title: 'Админ: errorlog'},
                            name: 'Логи ошибок',
                            component: NsbAdminFileViewer
                        },
                        {
                            path: 'queue',
                            meta: {title: 'Админ: очередь'},
                            name: 'Очередь',
                            component: NsbAdminQueue
                        },
                        {
                            path: 'orders',
                            meta: {title: 'Админ: заявки'},
                            name: 'Заявки',
                            component: NsbAdminOrders
                        },
                        {
                            path: '/admin/vouchers',
                            redirect: '/admin/vouchers/index',
                            name: 'Путевки',
                            meta: {title: 'Админ: путевки'},
                            component: { render (c) { return c('router-view') } },
                            children: [
                                {
                                    path: 'index',
                                    component: NsbAdminVouchers,
                                    name: 'Админ: список путевок',
                                    meta: {title: 'Список'},
                                },
                                {
                                    path: '/admin/voucher/:voucher_id',
                                    name: 'Путевка',
                                    meta: {title: 'Админ: путевка'},
                                    component: NsbAgentVoucher
                                },
                            ],
                        },
                        {
                            path: 'help',
                            name: '  Помощь',
                            component: NsbAdminHelp
                        },
                        {
                            path: 'bot-phrases',
                            name: '  Разметка фраз для бота',
                            component: NsbAdminBotPhrases
                        },
                        {
                            path: '/admin/companies',
                            redirect: '/admin/companies/index',
                            name: 'Компании',
                            meta: {title: 'Компании'},
                            component: { render (c) { return c('router-view') } },
                            children: [
                                {
                                    path: 'index',
                                    component: NsbAdminCompanies,
                                    name: 'Список компаний',
                                    meta: {title: 'Список компаний'},
                                },
                                {
                                    path: '/admin/company/:company_id',
                                    name: 'Компания',
                                    meta: {title: 'Компания'},
                                    component: NsbAdminCompany
                                },
                            ],
                        },
                        {
                            path: '/admin/users',
                            redirect: '/admin/users/index',
                            name: 'Пользователи',
                            meta: {title: 'Пользователи'},
                            component: { render (c) { return c('router-view') } },
                            children: [
                                {
                                    path: 'index',
                                    component: NsbAdminUsers,
                                    name: 'Список пользователей',
                                    meta: {title: 'Список пользователей'},
                                },
                                {
                                    path: '/admin/user/:user_id',
                                    name: 'Пользователь',
                                    meta: {title: 'Пользователь'},
                                    component: NsbAdminUser
                                },
                            ],
                        },

                        {
                            path: '/admin/sm/states',
                            name: 'Состояния',
                            meta: {title: 'Состояния'},
                            component: SmStates,
                        },
                        {
                            path: '/admin/sm/state/:state_id',
                            name: 'Состояние',
                            meta: {title: 'Состояние'},
                            component: SmState,
                        },
                        {
                            path: '/admin/sm/operations',
                            name: 'Переходы',
                            meta: {title: 'Переходы'},
                            component: SmOperations,
                        },
                        {
                            path: '/admin/sm/operation/:operation_id',
                            name: 'Переход',
                            meta: {title: 'Переход'},
                            component: SmOperation,
                        },

                        {
                            path: '/admin/sm/export',
                            name: 'Граф',
                            meta: {title: 'Граф'},
                            component: SmExport,
                        },
                        {
                            path: '/admin/sm/conditions',
                            name: 'Условия',
                            meta: {title: 'Условия'},
                            component: SmConditions,
                        },
                        {
                            path: '/admin/sm/condition/:condition_id',
                            name: 'Условие',
                            meta: {title: 'Условие'},
                            component: SmCondition,
                        },
                        {
                            path: '/admin/sm/functions',
                            name: 'Функции',
                            meta: {title: 'Функции'},
                            component: SmFunctions,
                        },
                        {
                            path: '/admin/sm/function/:func_id',
                            name: 'Функция',
                            meta: {title: 'Функция'},
                            component: SmFunction,
                        },

                    ]
                },

                // 1 пробел после
                {
                    path: 'agent',
                    redirect: '/agent/vouchers',
                    name: 'Агент ',
                    component: { render (c) { return c('router-view') } },
                    children: [
                        {
                            path: '/agent/vouchers',
                            redirect: '/agent/vouchers/index',
                            name: 'Путевки ',
                            meta: {title: 'Путевки'},
                            component: { render (c) { return c('router-view') } },
                            children: [
                                {
                                    path: 'index',
                                    component: NsbAgentVouchers,
                                    name: 'Список путевок ',
                                    meta: {title: 'Список путевок'},
                                },
                                {
                                    path: '/agent/voucher/:voucher_id',
                                    name: 'Путевка ',
                                    meta: {title: 'Путевка'},
                                    component: NsbAgentVoucher
                                },
                            ],
                        },
                        {
                            path: '/agent/orders',
                            redirect: '/agent/orders/index',
                            name: 'Заявки ',
                            meta: {title: 'Заявки'},
                            component: { render(c) { return c('router-view') } },
                            children: [
                                {
                                    path: 'index',
                                    name: 'Список заявок ',
                                    meta: {title: 'Список заявок'},
                                    component: NsbAgentOrders,
                                },
                                {
                                    path: '/agent/order/:order_id',
                                    name: 'Заявка ',
                                    meta: {title: 'Заявка'},
                                    component: NsbAgentOrder
                                },
                            ],
                        },
                        {
                            path: '/agent/tourhelper',
                            name: 'Подбор тура ',
                            meta: {title: 'Подбор тура'},
                            component: NsbAgentTourHelper,
                        },
                        {
                            path: '/agent/search',
                            name: 'Поиск по контактам ',
                            meta: {title: 'Поиск по контактам'},
                            component: NsbAgentSearch,
                        },
                        {
                            path: '/agent/reports',
                            name: 'Отчеты ',
                            meta: {title: 'Отчеты'},
                            component: NsbAgentReports,
                        },
                        {
                            path: '/agent/customers',
                            redirect: '/agent/customers/index',
                            name: 'Заказчики ',
                            meta: {title: 'Заказчики'},
                            component: { render(c) { return c('router-view') } },
                            children: [
                                {
                                    path: 'index',
                                    name: 'Список заказчиков ',
                                    meta: {title: 'Список заказчиков'},
                                    component: NsbAgentCustomers,
                                },
                                {
                                    path: '/agent/customer/:customer_id',
                                    name: 'Заказчик ',
                                    meta: {title: 'Заказчик'},
                                    component: NsbAgentCustomer
                                },
                            ],
                        },

                        {
                            path: '/agent/checkins',
                            meta: {title: 'График заездов'},
                            name: 'График заездов ',
                            component: NsbPanelCheckins
                        },


                        // {
                        //     path: 'index',
                        //     name: 'Все функции',
                        //     component: NsbAgentIndex
                        // },
                        // {
                        //     path: 'leads',
                        //     name: 'Лиды',
                        //     component: NsbAgentLeads
                        // },
                        // {
                        //     path: 'telecalls',
                        //     name: 'Звонки',
                        //     component: NsbAgentCalls
                        // },
                        // {
                        //     path: 'orders',
                        //     name: 'Заявки',
                        //     component: NsbAgentOrders
                        // },
                        // {
                        //     path: 'orders/:order_id',
                        //     name: 'Заявка',
                        //     component: NsbAgentOrder
                        // },
                        // {
                        //     path: 'incoming',
                        //     name: 'Входящий звонок',
                        //     component: NsbAgentIncoming
                        // },
                    ]
                },

                // 2 пробела после
                {
                    path: 'agency',
                    redirect: '/agency/dataexport',
                    name: 'Агентство  ',
                    component: { render (c) { return c('router-view') } },
                    children: [
                        {
                            path: '/agency/dataexport',
                            name: 'Экспорт данных  ',
                            meta: {title: 'Экспорт данных'},
                            component: NsbAgencyDataExport,
                        },
                        {
                            path: '/agency/dataimport',
                            name: 'Импорт данных  ',
                            meta: {title: 'Импорт данных'},
                            component: NsbAgencyDataImport,
                        },
                        {
                            path: '/agency/vouchers',
                            redirect: '/agency/vouchers/index',
                            name: 'Путевки  ',
                            meta: {title: 'Путевки'},
                            component: { render (c) { return c('router-view') } },
                            children: [
                                {
                                    path: 'index',
                                    component: NsbAgencyVouchers,
                                    name: 'Список путевок  ',
                                    meta: {title: 'Список'},
                                },
                                {
                                    path: '/agency/voucher/:voucher_id',
                                    name: 'Путевка  ',
                                    meta: {title: 'Путевка'},
                                    component: NsbAgentVoucher
                                },
                            ],
                        },
                        {
                            path: '/agency/orders',
                            redirect: '/agency/orders/index',
                            name: 'Заявки  ',
                            meta: {title: 'Заявки'},
                            component: { render (c) { return c('router-view') } },
                            children: [
                                {
                                    path: 'index',
                                    component: NsbAgencyOrders,
                                    name: 'Список заявок  ',
                                    meta: {title: 'Список'},
                                },
                                {
                                    path: '/agency/order/:order_id',
                                    name: 'Заявка  ',
                                    meta: {title: 'Заявка'},
                                    component: NsbAgentOrder
                                },
                            ],
                        },
                        {
                            path: '/agency/checkins',
                            meta: {title: 'График заездов  '},
                            name: 'График заездов  ',
                            component: NsbPanelCheckins
                        },
                        {
                            path: '/agency/fees',
                            name: 'Вознаграждение  ',
                            meta: {title: 'Вознаграждение'},
                            component: NsbAgencyFees,
                        },
                        {
                            path: '/agency/reports',
                            name: 'Отчеты  ',
                            meta: {title: 'Отчеты'},
                            component: NsbAgencyReports,
                        },

                        {
                            path: '/agency/payments',
                            name: 'Платежи  ',
                            meta: {title: 'Платежи'},
                            component: NsbAgencyPayments,
                        },

                        {
                            path: '/agency/finances',
                            name: 'Финансы  ',
                            meta: {title: 'Финансы'},
                            component: NsbAgencyFinances,
                        },

                        {
                            path: '/agency/profile',
                            name: 'Профайл агентства  ',
                            meta: {title: 'Профайл агентства'},
                            component: NsbAgencyProfile,
                        },

                        {
                            path: '/agency/profile',
                            name: 'Счет в системе  ',
                            meta: {title: 'Счет в системе'},
                            component: NsbAgencyAccount,
                        },
                    ]
                },

                // 3 пробела после
                {
                    path: 'manager',
                    redirect: '/manager/vouchers',
                    name: 'Менеджер ',
                    component: { render (c) { return c('router-view') } },
                    children: [
                        {
                            path: '/manager/vouchers',
                            redirect: '/manager/vouchers/index',
                            name: 'Путевки   ',
                            meta: {title: 'Менеджер: путевки'},
                            component: { render (c) { return c('router-view') } },
                            children: [
                                {
                                    path: 'index',
                                    component: NsbManagerVouchers,
                                    name: 'Список путевок   ',
                                    meta: {title: 'Менеджер: список путевок'},
                                },
                                {
                                     path: '/manager/voucher/:voucher_id',
                                     name: 'Путевка   ',
                                     meta: {title: 'Путевка'},
                                     component: NsbAgentVoucher
                                },
                            ],
                        },
                        {
                            path: '/manager/bookings',
                            redirect: '/manager/bookings/index',
                            name: 'Брони   ',
                            meta: {title: 'Менеджер: брони'},
                            component: { render (c) { return c('router-view') } },
                            children: [
                                {
                                    path: 'index',
                                    component: NsbManagerBookings,
                                    name: 'Список броней   ',
                                    meta: {title: 'Менеджер: список броней'},
                                },
                                {
                                    path: '/manager/booking/:booking_id',
                                    name: 'Бронь   ',
                                    meta: {title: 'Бронь'},
                                    component: NsbManagerBooking
                                },
                                {
                                    path: '/manager/bookingex/:booking_id',
                                    name: 'БроньВн   ',
                                    meta: {title: 'Бронь во внешней системе'},
                                    component: NsbManagerBookingEx
                                },
                            ],
                        },
                        {
                            path: '/manager/quotas',
                            redirect: '/manager/quotas/index',
                            name: 'Квоты   ',
                            meta: {title: 'Менеджер: квоты'},
                            component: { render (c) { return c('router-view') } },
                            children: [
                                {
                                    path: 'index',
                                    component: NsbManagerQuotas,
                                    name: 'Список квот   ',
                                    meta: {title: 'Менеджер: список квот'},
                                },
                                // {
                                //     path: '/manager/booking/:booking_id',
                                //     name: 'Бронь   ',
                                //     meta: {title: 'Бронь'},
                                //     component: NsbManagerBooking
                                // },
                                // {
                                //     path: '/manager/bookingex/:booking_id',
                                //     name: 'БроньВн   ',
                                //     meta: {title: 'Бронь во внешней системе'},
                                //     component: NsbManagerBookingEx
                                // },
                            ],
                        },
                        {
                            path: '/manager/checkins',
                            meta: {title: 'График заездов'},
                            name: 'График заездов   ',
                            component: NsbPanelCheckins
                        },

                        // {
                        //     path: '/agent/tourhelper',
                        //     name: 'Подбор тура ',
                        //     meta: {title: 'Подбор тура'},
                        //     component: NsbAgentTourHelper,
                        // },
                        // {
                        //     path: '/agent/search',
                        //     name: 'Поиск по контактам   ',
                        //     meta: {title: 'Поиск по контактам'},
                        //     component: NsbAgentSearch,
                        // },

                        // {
                        //     path: 'index',
                        //     name: 'Все функции',
                        //     component: NsbAgentIndex
                        // },
                        // {
                        //     path: 'leads',
                        //     name: 'Лиды',
                        //     component: NsbAgentLeads
                        // },
                        // {
                        //     path: 'telecalls',
                        //     name: 'Звонки',
                        //     component: NsbAgentCalls
                        // },
                        // {
                        //     path: 'orders',
                        //     name: 'Заявки',
                        //     component: NsbAgentOrders
                        // },
                        // {
                        //     path: 'orders/:order_id',
                        //     name: 'Заявка',
                        //     component: NsbAgentOrder
                        // },
                        // {
                        //     path: 'incoming',
                        //     name: 'Входящий звонок',
                        //     component: NsbAgentIncoming
                        // },
                    ]
                },

                // 1 пробел перед
                {
                    path: '/tech',
                    name: ' Техотдел',
                    component: { render (c) { return c('router-view') } },
                    children: [
                        {
                            path: 'hotels',
                            name: ' Объекты',
                            meta: {title: 'Объекты'},
                            component: { render (c) { return c('router-view') } },
                            redirect: '/tech/hotels/index',
                            children: [
                                {
                                    name: ' Список Объектов',
                                    meta: {title: 'Список'},
                                    path: 'index',
                                    component: NsbTechHotels,
                                },
                                {
                                    path: 'info/:hotel_id',
                                    name: ' Объект',
                                    meta: {title: 'Объект'},
                                    component: NsbTechHotel,
                                    // children: [
                                    //     {
                                    //         path: '/tech/hotel/:hotel_id/room/:room_id',
                                    //         name: 'Номер',
                                    //         meta: {title: 'Номер'},
                                    //         component: NsbTechRoom
                                    //     },
                                    //     {
                                    //         path: '/tech/hotel/:hotel_id/prog/:prog_id',
                                    //         name: 'Программа',
                                    //         meta: {title: 'Программа'},
                                    //         component: NsbTechProgram
                                    //     },
                                    // ],
                                },
                                {
                                    path: '/tech/webform',
                                    name: ' Веб-формы',
                                    meta: {title: 'Веб-формы'},
                                    component: NsbTechWebform,
                                },
                            ],
                        },
                        {
                            path: 'htypes',
                            name: ' Типы объектов',
                            meta: {title: 'Типы объектов'},
                            component: NsbTechHotelTypes,
                        },
                        {
                            path: 'diseases',
                            name: ' Заболевания',
                            meta: {title: 'Заболевания'},
                            component: NsbTechDiseases,
                        },
                        {
                            path: 'disease-categories',
                            name: ' Группы заболеваний',
                            meta: {title: 'Группы заболеваний'},
                            component: NsbTechDiseaseCategories,
                        },
                        {
                            path: 'services',
                            name: ' Инфраструктура объекта',
                            meta: {title: 'Инфраструктура объекта'},
                            component: NsbTechHotelServices,
                        },
                        {
                            path: 'room-features',
                            name: ' Инфраструктура номера',
                            meta: {title: 'Инфраструктура номера'},
                            component: NsbTechRoomServices,
                        },
                        {
                            path: 'cities',
                            name: ' Города',
                            meta: {title: 'Города'},
                            component: { render (c) { return c('router-view') } },
                            redirect: '/tech/cities/index',
                            children: [
                                {
                                    name: ' Список Городов',
                                    meta: {title: 'Список'},
                                    path: 'index',
                                    component: NsbTechCities,
                                },
                                {
                                    path: 'info/:city_id',
                                    name: ' Город',
                                    meta: {title: 'Город'},
                                    component: NsbTechCity
                                },
                            ],
                        },
                    ]
                },

                // 2 пробела перед
                {
                    path: 'buh',
                    redirect: '/buh/dataexport',
                    name: '  Бухгалтер',
                    component: { render (c) { return c('router-view') } },
                    children: [
                        {
                            path: '/buh/dataexport',
                            name: '  Экспорт данных',
                            meta: {title: 'Экспорт данных'},
                            component: NsbBuhDataExport,
                        },

                        {
                            path: '/buh/dataimport',
                            name: '  Импорт данных',
                            meta: {title: 'Импорт данных'},
                            component: NsbBuhDataImport,
                        },

                        {
                            path: '/buh/finances',
                            name: '  Финансы',
                            meta: {title: 'Финансы'},
                            component: NsbBuhFinances,
                        },

                        {
                            path: '/buh/balances',
                            name: '  Балансы',
                            meta: {title: 'Балансы'},
                            component: NsbBuhBalances,
                        },

                        {
                            path: '/buh/payments',
                            name: '  Платежи',
                            meta: {title: 'Платежи'},
                            component: NsbBuhPayments,
                        },

                        {
                            path: '/buh/vouchers',
                            redirect: '/buh/vouchers/index',
                            name: '  Путевки',
                            meta: {title: 'Бухгалтер: путевки'},
                            component: { render (c) { return c('router-view') } },
                            children: [
                                {
                                    path: 'index',
                                    component: NsbManagerVouchers,
                                    name: '  Список путевок',
                                    meta: {title: 'Бухгалтер: список путевок'},
                                },
                                {
                                    path: '/buh/voucher/:voucher_id',
                                    name: '  Путевка',
                                    meta: {title: 'Путевка'},
                                    component: NsbAgentVoucher
                                },
                            ],
                        },
                        {
                            path: '/buh/bookings',
                            redirect: '/buh/bookings/index',
                            name: '  Брони',
                            meta: {title: 'Бухгалтер: брони'},
                            component: { render (c) { return c('router-view') } },
                            children: [
                                {
                                    path: 'index',
                                    component: NsbManagerBookings,
                                    name: '  Список броней',
                                    meta: {title: 'Бухгалтер: список броней'},
                                },
                                {
                                    path: '/buh/booking/:booking_id',
                                    name: '  Бронь',
                                    meta: {title: 'Бронь'},
                                    component: NsbManagerBooking
                                },
                            ],
                        },
                        {
                            path: '/buh/reports',
                            name: '  Отчеты ',
                            meta: {title: 'Отчеты'},
                            component: NsbBuhReports,
                        },
                    ]
                },

                // 3 пробел перед
                {
                    path: '/webmaster',
                    name: '   Вебмастер',
                    component: { render (c) { return c('router-view') } },
                    children: [
                        {
                            path: '/webmaster/webform',
                            name: '   Веб-формы',
                            meta: {title: 'Веб-формы'},
                            component: NsbWebmasterWebform,
                        },
                    ]
                },


                {
                    path: 'profile',
                    name: 'Профайл',
                    meta: {title: 'Профайл'},
                    component: NsbPanelProfile,
                },
                {
                    path: 'messages',
                    name: 'Сообщения',
                    meta: {title: 'Сообщения'},
                    component: NsbPanelMessages,
                },
                {
                    path: '/tasks',
                    name: 'Задачи',
                    meta: {title: 'Задачи'},
                    redirect: '/tasks/index',
                    component: { render (c) { return c('router-view') } },
                    children: [
                        {
                            name: 'Список задач',
                            meta: {title: 'Список задач'},
                            path: '/tasks/index',
                            component: NsbPanelTasks,
                        },
                        {
                            path: '/tasks/bug-report',
                            name: 'Сообщение об ошибке',
                            meta: {title: 'Сообщение об ошибке'},
                            component: NsbPanelNewBug
                        },
                        {
                            path: '/tasks/feature-request',
                            name: 'Запрос функционала',
                            meta: {title: 'Запрос функционала'},
                            component: NsbPanelNewFeature
                        },
                        {
                            path: '/task/:task_id',
                            name: 'Задача',
                            meta: {title: 'Задача'},
                            component: NsbPanelTask
                        },
                    ],
                },
                {
                    path: 'telecalls',
                    name: 'Звонки     ',
                    meta: {title: 'Звонки'},
                    component: NsbPanelTelecalls,
                },
                {
                    path: 'lines',
                    name: 'Lines',
                    meta: {title: 'Lines'},
                    component: NsbLines,
                },
                {
                    path: 'incoming/:telenum',
                    name: 'Входящий звонок',
                    meta: {title: 'Входящий звонок'},
                    component: NsbIncoming,
                },
                {
                    path: 'incoming-x/:telenum',
                    name: 'Входящий звонокX',
                    meta: {title: 'Входящий звонокX'},
                    component: NsbIncomingX,
                },
                {
                    path: 'reports-docs',
                    name: 'Отчеты документы',
                    meta: {title: 'Отчеты документы'},
                    component: NsbReports,
                },
                {
                    path: 'help',
                    name: 'Справка',
                    meta: {title: 'Справка'},
                    component: NsbHelp,
                },

            ]
        },
        {
            path: '/pages',
            redirect: '/pages/404',
            name: 'Pages',
            component: {
                render (c) { return c('router-view') }
            },
            children: [
                {
                    path: '404',
                    name: 'Page404',
                    component: Page404
                },
                {
                    path: '500',
                    name: 'Page500',
                    component: Page500
                },
                {
                    path: 'login',
                    name: 'Login',
                    component: Login
                },
                // {
                //     path: 'register',
                //     name: 'Register',
                //     component: Register
                // }
            ]
        }
    ]
});


router.beforeEach((to, from, next) => {
    document.e_referrer = from;
    document.title = to.meta.title;
    if ((typeof localStorage.authtoken!=='undefined') && (localStorage.authtoken!=='undefined') &&  localStorage.authtoken) {
        next();
    }
    else {
        if (to.name !== 'Login') {
            next(false);
            router.push({ name: 'Login', params: { } })
        }
        else {
            next();
        }
    }
});

export default router;
